import React from 'react'
import styled from 'styled-components'

import LessSvg from './images/less.component.svg'
import PlusSvg from './images/more.component.svg'

export default class Counter extends React.Component {
  increment = (val) => {
    const { value } = this.props
    this.props.onChange && this.props.onChange({ value: value + 1 })
  }

  decrement = (val) => {
    const { value } = this.props
    this.props.onChange && this.props.onChange({ value: value - 1 })
  }

  render() {
    const { type, text, disabled, value, children, subLabel } = this.props

    return (
      <Container>
        <Image type={type}>
          <div>{children}</div>
          <span>
            {value}
            &nbsp;
            {text}
          </span>
          <SmallLabel>{subLabel}</SmallLabel>
        </Image>

        <Button
          less
          disabled={value === 0}
          onClick={() => {
            this.decrement(1)
          }}>
          <LessSvg />
        </Button>

        <Button
          plus
          margin
          onClick={() => {
            this.increment(1)
          }}
          disabled={disabled}>
          <PlusSvg />
        </Button>
      </Container>
    )
  }
}

export const Button = styled.button.attrs({
  type: 'button',
})`
  border: 1px solid #DEDEDE;

  position: relative;

  opacity: 0.5;


  ${({ disabled }) =>
    !disabled &&
    `
    cursor: pointer;
    opacity: 1.0;

    &:hover {
      opacity: 0.5;
    }

  `}

  outline: none;
  background: #FFF;

  display:block;


  float:left;

  width: calc(50% - 4px);


  margin-top: 8px;

  &:before,
  &:after {
    content:"";
    display:table;
  }

  &:after {
    clear:both;
  }

  &:focus {
    outline: none;

  }
  > * {
    pointer-events: none;
  }

  -webkit-transition: opacity 0.2s ease-in;
  transition: opacity 0.2s ease-in;




  ${({ margin }) => margin && `margin-left: 30px;`}

  ${({ less }) =>
    less &&
    `
    svg {
      margin-top: 16px;
      margin-bottom: 13px;

      width: 14px;
      path {
        fill: #93C13E;
      }
    }
  `}

  ${({ plus }) =>
    plus &&
    `
    margin-left: 8px;
    svg {

      margin-top: 10px;
      margin-bottom: 7px;

      width: 14px;
      height: 14px;

      path {
        fill: #93C13E;
      }
    }
  `}

  ${({ disabled }) =>
    disabled &&
    `
    svg {
      rect {
        fill: #DEDEDE;
      }
    }
  `}
`

const Image = styled.div`
  display: block;
  background: #FFF;
  border: 1px solid #DEDEDE;
  width: 118px;
  min-height: 118px;

  span {
    display:block;
    color: #010101;
    font-family: Nunito;
    font-size: 12px;
    font-weight: bold;
    line-height: 12px;
    text-align: center;
    text-transform: uppercase;
  }
  div {
    svg {
      width: 100%;
    }
  }

  ${({ type }) =>
    type === 'adultos'
      ? `
    div {
      margin-top: 26px;
      margin-left: 40px;
      margin-right: 40px;
      width: 40px;
      height: 40px;

    }
    span {
      margin-top: 16px;
    }
  `
      : ``}


  ${({ type }) =>
    type === 'criancas'
      ? `
    div {
      margin-top: 24px;
      margin-left: 37px;
      margin-right: 37px;

      width: 46px;
      height: 43px;
    }
    span {
      margin-top: 15px;
    }
  `
      : ``}

  ${({ type }) =>
    type === 'idosos'
      ? `
    div {
      margin-top: 22px;
      margin-left: 40px;
      margin-right: 40px;

      width: 40px;
      height: 48px;
    }
    span {
      margin-top: 12px;
    }
  `
      : ``}
`

const Container = styled.div`
  display: inline-block;

  width: 120px;
  min-height: 158px;

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  vertical-align: top;
`

const SmallLabel = styled.span`
  color: #7c7c7c !important;
  font-size: 9px !important;
  margin: 0 !important;
`



// WEBPACK FOOTER //
// ./src/components/Counter/index.js